import React, { useState } from 'react';
import axios from '../../axios';
import { Form, Button, Container, Alert } from 'react-bootstrap';

const EnrollmentUploadForm = ({ onUploadSuccess }) => {
  const [file, setFile] = useState(null);
  const [errors, setErrors] = useState([]);

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append('file', file);

    console.log('FormData content:', file);  // Debug xem file có được chọn và append vào FormData hay chưa

    try {
      console.log('Start call api:', localStorage.getItem('token'));  // Debug xem file có được chọn và append vào FormData hay chưa
      const res = await axios.post('/enrollments/import', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'x-auth-token': localStorage.getItem('token')
        }
      });
      console.log('End call api:');
      alert('Data imported successfully');      
      setErrors([]);
      if (onUploadSuccess) onUploadSuccess();
    } catch (err) {
      console.error('Error response:', err.response.data);  // Hiển thị rõ hơn lỗi trả về từ server
      if (err.response && err.response.data && err.response.data.errors) {
        setErrors(err.response.data.errors);
      } else {
        alert('Failed to import data');
      }
    }
};


  return (
    <Container>
      <Form onSubmit={handleSubmit}>
        <Form.Group>
          <Form.Label htmlFor="file">Choose Excel file</Form.Label>
          <Form.Control
            type="file"
            id="file"
            onChange={handleFileChange}
            accept=".xlsx"
            required
          />
        </Form.Group>
        <Button variant="primary" type="submit">Import</Button>
      </Form>
      {errors.length > 0 && (
        <Alert variant="danger" className="mt-3">
          <Alert.Heading>Errors during import</Alert.Heading>
          <ul>
            {errors.map((error, index) => (
              <li key={index}>Row {error.rowIndex}: {error.error}</li>
            ))}
          </ul>
        </Alert>
      )}
    </Container>
  );
};

export default EnrollmentUploadForm;
